exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".teams-check[data-v-072277b1]{position:relative;top:-35px;display:block;right:35px;margin-top:0}", ""]);

// exports
